import { Collapse } from "antd";
import { styled } from "styled-components";
import { Typography } from "styled/Typography";
import { theme } from "theme";

export const InputsGridContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media screen and (max-width: ${theme.breakpoints.s}) {
    grid-template-columns: 1fr;
  }
`;

export const Title = styled(Typography.Title)`
  font-weight: ${theme.fontWeight.semiBold};
`;

export const StyledCollapse = styled(Collapse)`
  .ant-collapse-header {
    padding: 4px 0 !important;
  }

  .ant-collapse-content-box {
    padding: 4px 0 !important;
  }
`;
